<ngb-carousel *ngIf="slides.length > 0; else placeholder">
    <ng-template ngbSlide *ngFor="let slide of slides; let i = index">
        <a *ngIf="slide.link; else noLink" [href]="slide.link" target="_blank" rel="noopener">
            <img class="carousel-img" [src]="slide.img" alt="{{slide.title}}" [attr.fetchpriority]="i === 0 ? 'high' : null">
        </a>
        <ng-template #noLink>
            <img class="carousel-img" [src]="slide.img" alt="{{slide.title}}" [attr.fetchpriority]="i === 0 ? 'high' : null">
        </ng-template>
    </ng-template>
</ngb-carousel>
<ng-template #placeholder>
    <div *ngIf="loading" class="carousel-skeleton"></div>
</ng-template>
